var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import { postWithAuthn } from "./RequestHelpers";
var LogOutPage = /** @class */ (function (_super) {
    __extends(LogOutPage, _super);
    function LogOutPage(props) {
        var _this = _super.call(this, props) || this;
        _this.loadProfile = function () {
            postWithAuthn('/user/log-out')
                .then(function (resp) {
                if (resp.ok) {
                    _this.setState({
                        loading: false
                    }, function () {
                        _this.props.authnObserver.onAuthnStateChanged();
                    });
                }
                else {
                    // This endpoint doesn't really have a failure mode, so leaving the spinner up seems reasonable
                }
                return;
            })
                .catch(function (rej) {
                console.error("Couldn't log out: " + rej);
            });
        };
        _this.state = {
            loading: true
        };
        return _this;
    }
    LogOutPage.prototype.render = function () {
        return React.createElement("div", { id: "non-header-portion" },
            React.createElement(Dimmer.Dimmable, { as: 'div' },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                !this.state.loading
                    &&
                        React.createElement("div", null, "You have been logged out")));
    };
    LogOutPage.prototype.componentDidMount = function () {
        this.loadProfile();
    };
    return LogOutPage;
}(React.PureComponent));
export default LogOutPage;
//# sourceMappingURL=LogOutPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/LogOutPage.js
// module id = 977
// module chunks = 0